import backofficeService from '../../api/backoffice'

export default {  
  getTeacherTimeOff(params = {}) {
    return backofficeService.Api().get('teacher-time-off', { params })
      .then(response => response.data)
      .catch(error => { throw error })
  },
  getSubscriptionGap(params = {}) {
    return backofficeService.Api().get('report/subscription-gap', { params })
      .then(response => response.data)
      .catch(error => { throw error })
  },
  getCollectionAttentionCount() {
    return backofficeService.Api().get('invoice/collection-attention/count')
      .then(response => response.data)
      .catch(error => { throw error })
  },
  getSadaqahSummary() {
    return backofficeService.Api().get('sadaqahFunding/summary')
      .then(response => response.data)
      .catch(error => { throw error })
  },
  getTeacherAttendancePerformance(params = {}) {
    return backofficeService.Api().get('attendance/teacher-performance-overview', { params })
      .then(response => response.data)
      .catch(error => { throw error })
  },
  getSalesByPeriod(params) {
    return backofficeService.Api().get('sales/salesByPeriod', { params })
      .then(response => response.data)
      .catch(error =>{ throw error})
  },
}
